import { LuArrowRight } from 'react-icons/lu';
import backgroundImage from '../../assets/hero_section_image.png';
import CustomButton from '../CommonComps/Buttons/CustomButton';

const HeroSection = () => {
  return (
    <section
      id='home'
      className='relative flex min-h-[80vh] items-center overflow-hidden bg-gradient-to-r from-legal-black via-legal-dark-blue to-legal-dark-gray md:min-h-[90vh] lg:min-h-screen'
    >
      {/* Background Image with Overlay */}
      <span className='absolute inset-0 z-10 bg-gray-900/85 md:bg-black/50'></span>
      <img
        src={backgroundImage}
        alt='Background'
        className='absolute -bottom-10 z-0 h-full w-full object-cover md:-right-20 xl:-right-36 xl:object-contain'
      />

      {/* Content Container */}
      <div className='z-10 mx-auto flex w-full max-w-[95rem] items-center px-4 sm:px-6 lg:px-8'>
        <div className='w-full text-center transition-all duration-300 md:text-left lg:ml-8'>
          <h1 className='mb-4 font-playfair text-3xl font-bold tracking-wide sm:text-4xl md:mb-6 md:text-5xl lg:text-6xl xl:text-7xl'>
            <span className='text-white'>Expert </span>
            <span className='text-legal-white'>Legal Solutions</span>
            <br />
            <span className='italic leading-snug text-legal-brown'>
              at Your Fingertips
            </span>
          </h1>

          <p className='mx-auto mb-6 font-marcellus text-base text-white sm:text-lg md:mx-0 md:mb-8 md:max-w-xl md:text-xl lg:max-w-3xl lg:text-2xl'>
            Connect with top legal consultants through secure video calls,
            manage your documents, and get professional solutions for your legal
            matters.
          </p>

          <div className='flex justify-center md:justify-start'>
            <CustomButton
              title='Learn More'
              onClick={() => {}}
              icon={
                <LuArrowRight className='size-5 duration-500 group-hover:rotate-90' />
              }
              variant='secondary'
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
